// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import { CustomAppState } from "@vanmeter/App/Store/Reducers";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const deliveryInfo = (props.getState() as CustomAppState).xCheckout.deliveryInfo;
    const releaseNumber = (props.getState() as CustomAppState).xCheckout.releaseNumber;
    const notes = (props.getState() as CustomAppState).xCheckout.notes;

    const { shippingInstructions, pickupInstructions, carrierAccountNumber } = deliveryInfo ?? {};

    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            notes: notes || "",
            properties: {
                ...props.apiParameter.cart.properties,
                ...(shippingInstructions && { shippingInstructions }),
                ...(pickupInstructions && { pickupInstructions }),
                ...(carrierAccountNumber && { carrierAccountNumber }),
                ...(releaseNumber && { releaseNumber }),
            },
        },
    };
};

export const DispatchDataCleanup: any = (props: any) => {
    props.dispatch({
        type: "xCheckout/Reset",
    } as any);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, DispatchDataCleanup);
